// src/context/ResponsiveContext.js
import React, { createContext } from "react";
import { useMediaQuery } from "react-responsive";
import { breakpoints } from "../utilities/mediaQueries";

const ResponsiveContext = createContext();

const ResponsiveProvider = ({ children }) => {
  const isDesktop = useMediaQuery({ query: breakpoints.desktop });
  const isTablet = useMediaQuery({ query: breakpoints.tablet });
  const isMobile = useMediaQuery({ query: breakpoints.mobile });

  return (
    <ResponsiveContext.Provider value={{ isDesktop, isTablet, isMobile }}>
      {children}
    </ResponsiveContext.Provider>
  );
};

export { ResponsiveContext, ResponsiveProvider };
